import React from 'react';
import { Tooltip } from '@material-ui/core';
import StudentActivityRow from './StudentActivityRow';
import styles from './StudentActivityTable.module.css';
import MLButton from '../../../components/MLButton';
import MLIcon from '../../../components/MLIcon';
import { STUDENT_ACTIVITY_COLUMN_HEADERS } from '../../constants';
import { sortStudents } from '../../utils/sortUtils';
import { useSortableTable } from '../../../hooks/useSortableTable';

const getStudentKey = (student) =>
  student.studentId || student.id || student.email || JSON.stringify(student);

export const StudentActivityTable = ({
  students,
  studentsWithoutActivity,
  handleISGLaunch,
  setOpen,
  days,
}) => {
  const { sortBy, sortOrder, iconType, handleColumnClick } = useSortableTable(
    STUDENT_ACTIVITY_COLUMN_HEADERS.LAST_ACTIVITY_LAUNCH
  );

  const sortedStudents = sortStudents(students, sortBy, sortOrder);

  const renderHeader = (columnHeader) => (
    <button
      className={styles.headerText}
      onClick={() => handleColumnClick(columnHeader)}
    >
      {columnHeader}
      {sortBy === columnHeader && (
        <MLIcon className={styles.caretIcon} type={iconType} />
      )}
    </button>
  );

  const onCopyEmailsClick = () => {
    const emails = studentsWithoutActivity
      .map((student) => student.email)
      .join(',');

    navigator.clipboard.writeText(emails);
  };

  const renderCopyEmailsButton = () => {
    const tooltipText = `Copy emails of students without an activity 
      launch in the last ${days} ${days === 1 ? 'day' : 'days'} 
      to your clipboard.`;
    return (
      <Tooltip title={tooltipText} placement="top" arrow enterDelay={400}>
        <div>
          <MLButton
            className={styles.copyEmailsBtn}
            btnType="secondary"
            onClick={onCopyEmailsClick}
            data-test-id="activity_launch_bet_copy_emails_btn"
            testId="activity_launch_bet_copy_emails_btn"
          >
            <MLIcon type="item_copy" className={styles.copyIcon} />
            <span>Copy Inactive Student Emails</span>
          </MLButton>
        </div>
      </Tooltip>
    );
  };

  return (
    <table className={styles.studentTable}>
      <thead>
        <tr className={styles.tableHeader}>
          <th className={styles.studentNameHeader}>
            {renderHeader(STUDENT_ACTIVITY_COLUMN_HEADERS.STUDENT_NAME)}
            {renderCopyEmailsButton()}
          </th>
          <th className={styles.launchHeader}>
            {renderHeader(STUDENT_ACTIVITY_COLUMN_HEADERS.LAST_ACTIVITY_LAUNCH)}
          </th>
        </tr>
      </thead>
      <tbody>
        {sortedStudents.map((student) => (
          <StudentActivityRow
            key={getStudentKey(student)}
            student={student}
            studentsWithoutActivity={studentsWithoutActivity}
            handleISGLaunch={handleISGLaunch}
            setOpen={setOpen}
          />
        ))}
      </tbody>
    </table>
  );
};
